import React, { FunctionComponent, ReactElement } from 'react';
import { Link, MessageBar, MessageBarButton, MessageBarType } from 'office-ui-fabric-react';
// TODO:  Should we migrate to fluentui/react-components?

type ButtonTextAndFn = {
  buttonText: string;
  buttonFn: () => any;
};

interface INotificationBannerProps {
  /** Defines the message type. Import MessageBarType from office-ui-fabric-react.
   * Example: messageType={MessageBarType.success} */
  messageType: MessageBarType;
  /** The message that you want to render. */
  message: string;
  /** Href for a link. If you'd like to include a link, linkHref is required.
   * If no linkText is provided, the linkHref will be displayed. */
  linkHref?: string;
  /** Text for a link. If you'd like to include a link, linkHref is required.
   * If no linkText is provided, the linkHref will be displayed. */
  linkText?: string;
  /** When set to true (false by default), your message will truncate and a 'See more' icon will render.
   * Truncation can not be used with buttons. */
  isTruncated?: boolean;
  /** Add buttons on the same line as your message. Takes an Array of Objects. Each object needs two properties: buttonText and buttonFn. */
  addButtonsInline?: Array<ButtonTextAndFn>;
  /** Add buttons on a new line. Takes an Array of Objects. Each object needs two properties: buttonText and buttonFn. */
  addButtonsOnNewLine?: Array<ButtonTextAndFn>;
  /*Dates when banner is active */
  StartDate: Date;
  EndDate: Date;
}

export const NotificationBanner: FunctionComponent<INotificationBannerProps> = ({
  messageType,
  message,
  linkHref,
  linkText,
  isTruncated = false,
  addButtonsInline,
  addButtonsOnNewLine,
  StartDate,
  EndDate,
}): ReactElement => {
  const [showBanner, setShowBanner] = React.useState<boolean>(StartDate < EndDate);

  const renderBanner = () => {
    if (showBanner == true) {
      return (
        <MessageBar
          actions={renderButtons()}
          messageBarType={messageType}
          isMultiline={!addButtonsInline?.length && !isTruncated}
          truncated={isTruncated}
          overflowButtonAriaLabel={isTruncated ? 'See more' : undefined}
          onDismiss={() => setShowBanner(false)}
          dismissButtonAriaLabel="Close"
        >
          {message}
          {renderLink()}
        </MessageBar>
      );
    }

    return <></>;
  };

  return <div>{renderBanner()}</div>;

  function renderLink(): ReactElement | null {
    if (!linkHref) return null;
    return (
      <Link href={linkHref} target="_blank" rel="noopener noreferrer" underline>
        {linkText || linkHref}
      </Link>
    );
  }

  function renderButtons(): ReactElement | undefined {
    if ((!addButtonsInline?.length && !addButtonsOnNewLine?.length) || isTruncated) return undefined;
    if (addButtonsInline?.length)
      return (
        <div>
          {addButtonsInline?.map(({ buttonText, buttonFn }, i) => (
            <MessageBarButton key={i} ariaLabel={buttonText} onClick={buttonFn}>
              {buttonText}
            </MessageBarButton>
          ))}
        </div>
      );

    return (
      <div>
        {addButtonsOnNewLine?.map(({ buttonText, buttonFn }, i) => (
          <MessageBarButton key={i} ariaLabel={buttonText} onClick={buttonFn}>
            {buttonText}
          </MessageBarButton>
        ))}
      </div>
    );
  }
};
